import { useEffect, useState } from 'react';
const QUERY = '(prefers-reduced-motion: reduce)';
function readPreference() {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function')
        return false;
    return window.matchMedia(QUERY).matches;
}
/**
 * Whether the viewer asked for less motion. CSS alone can stop an animation,
 * but the trace also swaps its words (a shimmering label becomes a fixed
 * "En cours…"), which needs the answer in render.
 */
export function usePrefersReducedMotion() {
    const [prefers, setPrefers] = useState(readPreference);
    useEffect(() => {
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function')
            return undefined;
        const query = window.matchMedia(QUERY);
        const onChange = () => setPrefers(query.matches);
        query.addEventListener?.('change', onChange);
        return () => query.removeEventListener?.('change', onChange);
    }, []);
    return prefers;
}
